import script from "./BankerStartGame.vue?vue&type=script&setup=true&lang=js"
export * from "./BankerStartGame.vue?vue&type=script&setup=true&lang=js"

import "./BankerStartGame.vue?vue&type=style&index=0&id=011f8bba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-011f8bba"]])

export default __exports__